export const oauth = {
  GOOGLE_AUTHORIZATION_REDIRECT_URI: process.env.NEXT_PUBLIC_GOOGLE_AUTHORIZATION_REDIRECT_URI as string,
  GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID as string,
  APP_DOMAIN: process.env.NEXT_PUBLIC_APP_DOMAIN as string,
}
